import { Fragment } from 'react';
import { BackgroundType } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage';
import { GridTwoByTwoItemProps } from '@zola/zola-ui/src/components/PreAuthV3/GridTwoByTwo';

import styled from '@emotion/styled';
import { COLORS3, SPACING } from '@zola/zola-ui/src/styles/emotion';

import type { ButtonV3Props } from '@zola/zola-ui/src/components/ButtonV3/ButtonV3';

import { LinkV2 } from '@zola/zola-ui/src/components/LinkV2';
import GridItem1Desktop from '../../../../public/static-preauth/images/SeatingChartLp/grid/device_desktop_2.webp';
import GridItem1Mobile from '../../../../public/static-preauth/images/SeatingChartLp/grid/device_mobile_2.webp';
import GridItem2Desktop from '../../../../public/static-preauth/images/SeatingChartLp/grid/customize_desktop.webp';
import GridItem2Mobile from '../../../../public/static-preauth/images/SeatingChartLp/grid/customize_mobile.webp';
import GridItem3Desktop from '../../../../public/static-preauth/images/SeatingChartLp/grid/premium_desktop_3_2.webp';
import GridItem3Mobile from '../../../../public/static-preauth/images/SeatingChartLp/grid/premium_mobile_3_2.webp';

const CTA = 'Download the iOS app';
const BUTTON_OVERRIDES: ButtonV3Props = {
  textTransform: false,
  size: 'large',
};

const StyledUl = styled.ul`
  list-style-type: disc;
`;
const StyledLi = styled.li`
  margin-left: ${SPACING.S24};
`;

export const gridItems = (
  appStoreUrl: string,
  appStoreOnClick: () => void
): GridTwoByTwoItemProps[] => [
  {
    copy: {
      header: 'Wedding seating assignments made easy',
      body: (
        <Fragment>
          <StyledUl>
            <StyledLi>Categorize your guests by group</StyledLi>
            <StyledLi>Add cake tables, dance floors, and more</StyledLi>
            <StyledLi>Export PDFs to create your seating chart poster</StyledLi>
          </StyledUl>
        </Fragment>
      ),
    },
    href: appStoreUrl,
    onClick: appStoreOnClick,
    linkText: CTA,
    buttonPropOverrides: BUTTON_OVERRIDES,
    image: {
      background: {
        parameters: {
          color: `var(--background-screen, ${COLORS3.WHITE_100})`,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem1Desktop,
        imgType: 'webp',
        mobileSrc: GridItem1Mobile,
        tabletSrc: GridItem1Desktop,
        alt: 'Zola iOS app with seating chart feature',
        loading: 'lazy',
      },
    },
  },
  {
    copy: {
      header: 'Customize seating for every wedding event',
      body: 'Choose the shape of your tables, number of seats, and layout of the room for all your wedding celebrations, not just the reception.',
    },
    href: appStoreUrl,
    onClick: appStoreOnClick,
    linkText: CTA,
    buttonPropOverrides: BUTTON_OVERRIDES,
    image: {
      background: {
        parameters: {
          color: `var(--background-screen, ${COLORS3.WHITE_100})`,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem2Desktop,
        imgType: 'webp',
        mobileSrc: GridItem2Mobile,
        tabletSrc: GridItem2Desktop,
        alt: 'Customize your Zola seating chart',
        loading: 'lazy',
      },
    },
  },
  {
    copy: {
      header: 'Upgrade your experience & save on your paper suite',
      body: (
        <Fragment>
          Unlock premium seating chart features to seat unlimited guests and get $15 off your next
          paper purchase!{' '}
          <LinkV2 sizes="extraSmall" arrow href="/discount-terms/1229766">
            * See terms
          </LinkV2>
        </Fragment>
      ),
    },
    href: appStoreUrl,
    onClick: appStoreOnClick,
    linkText: CTA,
    buttonPropOverrides: BUTTON_OVERRIDES,
    image: {
      background: {
        parameters: {
          color: `var(--background-screen, ${COLORS3.WHITE_100})`,
        },
        type: BackgroundType.COLOR,
      },
      foregroundImage: {
        desktopSrc: GridItem3Desktop,
        imgType: 'webp',
        mobileSrc: GridItem3Mobile,
        tabletSrc: GridItem3Desktop,
        alt: 'Unlock premium features',
        loading: 'lazy',
      },
    },
  },
];
